import {Component, OnInit} from '@angular/core';
import {EnergyMapDonatedComponent} from "../../energy-map/energy.map.donated.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {ModeratRequestService} from "../services/request.service";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";
import {MatDialog} from "@angular/material/dialog";

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-moderat-energy-map-donated',
    templateUrl: '../../energy-map/energy.map.donated.component.html',
    standalone: false
})
export class ModeratEnergyMapDonatedComponent extends EnergyMapDonatedComponent implements OnInit {
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService,
              protected portalService: PortalService, protected requestService: ModeratRequestService,
              protected energyMapService: EnergyMapService, public dialog: MatDialog) {
    super(stepService, router, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.advisorName = 'moderat';
    this.textkeyPrefix = 'moderat';
    this.anfrage = this.requestService.getAnfrage();
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.requestService.backendService.getEnergyMapHash(requestId).subscribe(energyMapHash => {
        this.hashCode = energyMapHash;
      });
    });

    super.ngOnInit();

    this.lastStep = '/' + this.portalService.currentPortalId + '/moderat/bestandsaufnahme/daemmung/3';
    this.nextStep = '/' + this.portalService.currentPortalId + '/moderat/sanierung/massnahmen';
  }
}
